















import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class ValueDisplayer extends Mixins<BaseComponent>(BaseComponent) {

  @Prop(String)
  private title!: string;

  @Prop(Number)
  private value!: number;

  @Prop({type: String, default: null})
  private subValue!: string | null;

  @Prop(String)
  private icon!: string;

  @Prop(String)
  private iconColor!: string;

}
